export enum ResourceDownloadsStatus {
  OnTime = "OnTime",
  DueSoon = "DueSoon",
  Overdue = "Overdue",
  NoDownloads = "NoDownloads"
}
